import { Pipe, PipeTransform, inject } from '@angular/core';
import { DATABASE_VERTICAL } from '@maximizer/outlook/shared/domain';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateVertical',
  pure: false,
})
export class TranslateVerticalPipe implements PipeTransform {
  private readonly vertical = inject(DATABASE_VERTICAL);
  private readonly translate = inject(TranslateService);

  transform(key: string): string {
    return this.translate.instant(`outlook.entries.${this.vertical()}.${key}`);
  }
}
